module.exports = __webpack_public_path__ + "static/media/tas.eabe730a.webp";